import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { GovRow } from "./GovRow";
import { GovRowParser_B02既往病史_B02自覺症狀 } from "./GovRowParser_B02既往病史_B02自覺症狀";
import { GovRowParser_作業經歷 } from "./GovRowParser_作業經歷";
import { GovRowParser_既往病史_自覺症狀 } from "./GovRowParser_既往病史_自覺症狀";
import { GovRowParser_檢查時期 } from "./GovRowParser_檢查時期";
import { GovRowParser_環境監測 } from "./GovRowParser_環境監測";
import { GovRowParser_生活習慣 } from "./GovRowParser_生活習慣";
import { GovRowParser_疲勞狀況 } from "./GovRowParser_疲勞狀況";
import { HisBasic } from "./HisBasic";
import { SpwkMetaTable } from "./SpwkMetaTable";




export class GovRowHelper {

  static ConvertTo申報格式(func_guid: string, func_code: string, his_basic: HisBasic, meta_table: SpwkMetaTable): GovRow[] {

    const steps = GetSpwkGovStepList(func_guid);// 不同特作，解碼步驟可能略有不同

    let re: GovRow[] = [];

    //  1.檢查時期(原因) 、2.作業經歷、3.既往病史、4.生活習慣、5.自覺症狀、6.疲勞狀況、7.作業環境監測資料

    for (const step of steps) {
      if (step.Chapter === SpwkUtilV3.CHAPTER_檢查時期) {// 1
        let data_row = GovRowParser_檢查時期.ConvertToHisRow(func_code, step, his_basic, meta_table);
        re.push(data_row);

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_作業經歷) {// 2
        let data_row_list = GovRowParser_作業經歷.ConvertToHisRow(func_guid, func_code, step, his_basic, meta_table);
        re = re.concat(data_row_list);

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_既往病史 || step.Chapter === SpwkUtilV3.CHAPTER_自覺症狀) {// 3 || 5
        let data_row_list = GovRowParser_既往病史_自覺症狀.ConvertToHisRow(step, his_basic, meta_table);
        re = re.concat(data_row_list);

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_既往病史_噪音作業 || step.Chapter === SpwkUtilV3.CHAPTER_自覺症狀_噪音作業) {// 3 || 5
        let data_row_list = GovRowParser_B02既往病史_B02自覺症狀.ConvertToHisRow(func_guid, func_code, step, his_basic, meta_table);
        re = re.concat(data_row_list);

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_生活習慣) {//4
        let data_row_list = GovRowParser_生活習慣.ConvertToHisRow(func_guid, func_code, step, his_basic, meta_table);
        re = re.concat(data_row_list);

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_疲勞狀況) {//6
        let data_row_list = GovRowParser_疲勞狀況.ConvertToHisRow(func_guid, func_code, step, his_basic, meta_table)
        re = re.concat(data_row_list);
      } else if (step.Chapter === SpwkUtilV3.CHAPTER_環境監測) {//7
        let data_row_list = GovRowParser_環境監測.ConvertToHisRow(func_code, step, his_basic, meta_table);
        re = re.concat(data_row_list);

      }

    }

    return re;
  }

}


export class SpwkGovStep {

  Gov問卷類別 = "";//  1.檢查時期(原因) 、2.作業經歷、3.既往病史、4.生活習慣、5.自覺症狀、6.疲勞狀況、7.作業環境監測資料
  Chapter = "";

  constructor(Gov問卷類別: string, Chapter: string) {
    this.Gov問卷類別 = Gov問卷類別;
    this.Chapter = Chapter;
  }


}


/**
* @param func_code - "A01"、"A98"...
*/
function GetSpwkGovStepList(func_guid: string) {
  const re: SpwkGovStep[] = [];

  if (func_guid === SpwkUtilV3.A01_func_guid) {

  } else if (func_guid === SpwkUtilV3.A98_func_guid) {
    re.push(new SpwkGovStep("2", SpwkUtilV3.CHAPTER_作業經歷));
    re.push(new SpwkGovStep("3", SpwkUtilV3.CHAPTER_既往病史));
    re.push(new SpwkGovStep("4", SpwkUtilV3.CHAPTER_生活習慣));
    re.push(new SpwkGovStep("5", SpwkUtilV3.CHAPTER_自覺症狀));
    re.push(new SpwkGovStep("6", SpwkUtilV3.CHAPTER_疲勞狀況));

  } else {
    //  1.檢查時期(原因) 、2.作業經歷、3.既往病史、4.生活習慣、5.自覺症狀、6.疲勞狀況、7.作業環境監測資料
    re.push(new SpwkGovStep("1", SpwkUtilV3.CHAPTER_檢查時期));
    re.push(new SpwkGovStep("2", SpwkUtilV3.CHAPTER_作業經歷));
    re.push(new SpwkGovStep("3", SpwkUtilV3.CHAPTER_既往病史));
    re.push(new SpwkGovStep("3", SpwkUtilV3.CHAPTER_既往病史_噪音作業));
    re.push(new SpwkGovStep("4", SpwkUtilV3.CHAPTER_生活習慣));
    re.push(new SpwkGovStep("5", SpwkUtilV3.CHAPTER_自覺症狀));
    re.push(new SpwkGovStep("5", SpwkUtilV3.CHAPTER_自覺症狀_噪音作業));
    re.push(new SpwkGovStep("6", SpwkUtilV3.CHAPTER_疲勞狀況));
    re.push(new SpwkGovStep("7", SpwkUtilV3.CHAPTER_環境監測));
  }

  return re;



}

